<nav class="navbar navbar-main navbar-dark bg-dark pb-0">
  <div class="container">
    <ul class="nav nav-tabs flex-nowrap">
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['users']" routerLinkActive="active">
          {{ 'admin.navigation.users' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          [routerLink]="['applications']"
          routerLinkActive="active"
        >
          {{ 'admin.navigation.oauth_applications' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          [routerLink]="['announcements']"
          routerLinkActive="active"
        >
          {{ 'admin.navigation.announcements' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['pools']" routerLinkActive="active">
          {{ 'admin.navigation.pools' | translate }}
        </a>
      </li>
    </ul>
  </div>
</nav>
